import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.dp.profiling_score"))),
      ]),
      _c("b-overlay", {
        attrs: { show: _vm.busy, "no-wrap": "", fixed: "" },
        scopedSlots: _vm._u([
          {
            key: "overlay",
            fn: function () {
              return [
                _vm.processing
                  ? _c(
                      "div",
                      [
                        _c("b-spinner", { attrs: { variant: "secondary" } }),
                        _c("p", [_vm._v(_vm._s(_vm.overlay_message) + " ...")]),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        ref: "dialog",
                        staticClass: "text-center p-3",
                        attrs: {
                          tabindex: "-1",
                          role: "dialog",
                          "aria-modal": "false",
                          "aria-labelledby": "form-confirm-label",
                        },
                      },
                      [
                        _c("p", [
                          _c(
                            "strong",
                            { attrs: { id: "form-confirm-label" } },
                            [_vm._v(_vm._s(_vm.$t("frases.sure")))]
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "mr-3",
                                attrs: {
                                  variant: "outline-danger",
                                  size: "sm",
                                },
                                on: { click: _vm.onCancelDelete },
                              },
                              [_vm._v(_vm._s(_vm.$t("botones.boton_cancelar")))]
                            ),
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: "outline-success",
                                  size: "sm",
                                },
                                on: { click: _vm.onConfirmDelete },
                              },
                              [_vm._v("OK")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "actions-component",
        [
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: {
                    click: function ($event) {
                      _vm.$refs["form-tabla" + _vm.tab].showModal(
                        false,
                        "create"
                      )
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-add")]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_crear"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VTabs,
        {
          attrs: { vertical: "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(VTab, [_vm._v(_vm._s(_vm.$t("tablas.validation_type")))]),
          _c(
            VTabItem,
            [
              _c("profiling-table-parameters", {
                ref: "form-tabla0",
                attrs: {
                  fields: _vm.fields,
                  deleteValidationType: false,
                  modalName: _vm.$t("tablas.validation_type"),
                },
              }),
            ],
            1
          ),
          _c(VTab, [_vm._v(_vm._s(_vm.$t("tablas.field_type")))]),
          _c(
            VTabItem,
            [
              _c("profiling-table-parameters", {
                ref: "form-tabla1",
                attrs: {
                  stateName: "score_field_types",
                  modalId: _vm.MODAL_SCORE_FIELD_TYPE,
                  fields: _vm.fields_sf,
                  dispatchName: "data-platform/getProfilingScoreFieldType",
                  modalName: _vm.$t("tablas.field_type"),
                },
              }),
            ],
            1
          ),
          _c(VTab, [_vm._v(_vm._s(_vm.$t("tablas.thresholds")))]),
          _c(
            VTabItem,
            [
              _c("profiling-table-parameters", {
                ref: "form-tabla2",
                attrs: {
                  stateName: "score_table_rules",
                  modalId: _vm.MODAL_SCORE_TABLE_RULE,
                  fields: _vm.fields_st,
                  dispatchName: "data-platform/getProfilingScoreTableRule",
                  modalName: _vm.$t("tablas.thresholds"),
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }